import { useEffect } from 'react';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';
import filter from 'lodash/filter';

import FeaturedListingCollection from './FeaturedListingCollection';

import UserItemActions from 'app/shared/flux/actions/UserItemActions';

import type { RootReduxState } from '../../flux/reducers';
import type { ListingDetails } from '@/srcLegacy/types/listingDetails.type';

interface RecentlyViewedV2Props {
  dispatch: Dispatch;
  viewedListings: Array<ListingDetails>;
  onListingClick: () => void;
  screenWidthForDesktopSRPFilter: 'sm' | 'md' | 'lg' | 'xl';
}

const RecentlyViewed = ({ viewedListings, onListingClick, screenWidthForDesktopSRPFilter }: RecentlyViewedV2Props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    // @ts-expect-error -- need to fix Typescript for getUserItems action first
    dispatch(UserItemActions.getUserItems('viewed', 0, 5));
  }, [dispatch]);

  if (viewedListings.length === 0) {
    return null;
  }

  return (
    <FeaturedListingCollection
      header="Recently viewed homes"
      isTreatingListingsNotViewed={true}
      listings={viewedListings}
      onListingClick={onListingClick}
      screenWidthForDesktopSRPFilter={screenWidthForDesktopSRPFilter}
      propertyCardTriggerLocation="recently_viewed_listings_module"
      triggerLocation={'home_details'}
      triggerObject={'home_details_component|recently_viewed'}
    />
  );
};

const mapStateToProps = (state: RootReduxState) => {
  return {
    currentListing: state.currentListingDetails.currentListing,
    viewedListings: filter(state.listings.listingGroups.viewed.slice(0, 5), (listing) => {
      if (
        state.location.current.pathname === listing.uriMalone ||
        state.location.current.pathname === listing.uriBuilding ||
        state.location.current.pathname === listing.uriV2
      ) {
        return false; // filter out the current listing/building
      } else {
        return true;
      }
    }),
  };
};

export default connect(mapStateToProps)(RecentlyViewed);
